import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgHome = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23 15.5V23c0 .27-.099.505-.297.703A.961.961 0 0 1 22 24h-6v-6h-4v6H6a.961.961 0 0 1-.703-.297A.961.961 0 0 1 5 23v-7.5c0-.01.003-.026.008-.047a.213.213 0 0 0 .008-.047L14 8l8.984 7.406c.01.021.016.052.016.094zm3.484-1.078-.968 1.156a.531.531 0 0 1-.328.172h-.047a.48.48 0 0 1-.328-.11L14 6.626 3.187 15.641a.58.58 0 0 1-.375.109.531.531 0 0 1-.328-.172l-.968-1.156a.507.507 0 0 1-.11-.367.454.454 0 0 1 .172-.336l11.235-9.36c.333-.27.729-.406 1.187-.406.458 0 .854.136 1.188.406L19 7.547V4.5a.49.49 0 0 1 .14-.36.487.487 0 0 1 .36-.14h3a.49.49 0 0 1 .36.14.49.49 0 0 1 .14.36v6.375l3.422 2.844a.453.453 0 0 1 .172.336.507.507 0 0 1-.11.367z" />
  </svg>
);
export default SvgHome;
